// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__3YLgH","itemTitle":"ClientEmergencyInfo_itemTitle__1efJ5","itemText":"ClientEmergencyInfo_itemText__3JRM9"};